"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const Button_1 = __importDefault(require("./Button"));
function Label(props) {
    const { title, shortTitle, className = '', children, style, description, renderTitle, ...otherProps } = props;
    return ((0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center', ...style?.container }, children: [(0, jsx_runtime_1.jsxs)("label", { className: className, style: {
                    fontSize: '12px',
                    color: '#232323',
                    paddingRight: '10px',
                    width: 'max-content',
                    ...style?.label,
                }, ...otherProps, children: [renderTitle ? (renderTitle(title)) : ((0, jsx_runtime_1.jsx)("span", { className: shortTitle ? 'large-label' : '', children: title })), shortTitle && ((0, jsx_runtime_1.jsx)("span", { className: "small-label", css: (0, react_1.css)({ display: 'none' }), children: shortTitle })), description && ((0, jsx_runtime_1.jsx)(Button_1.default.Info, { toolTip: description, tooltipOrientation: "horizontal", style: { display: 'inline-block' }, backgroundColor: { hover: 'white', base: 'white' }, color: { base: 'gray', hover: 'black' } }))] }), (0, jsx_runtime_1.jsx)("div", { style: style?.wrapper, children: children })] }));
}
exports.default = Label;
